import React, { useState } from 'react'
import { login } from '../../Services/Authentication';
import { useNavigate } from 'react-router-dom';


const Login: React.FunctionComponent<{}> = (props) => {

    const [formData, setFormData] = useState({
        email: 'founder2@coralytics.com',
        password: ''
    });
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({
        email: '',
        password: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState<string>();


    const validateEmail = (email: string) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error when user starts typing
        if (errors[name as keyof typeof errors]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleShowPassword = () => {
        setShowPassword(prev => !prev);
        console.log("Show password clicked", showPassword);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Validate form
        const newErrors = {
            email: '',
            password: ''
        };
        setIsLoading(true);

        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else if (!validateEmail(formData.email)) {
            newErrors.email = 'Please enter a valid email';
        }
        if (!formData.password) {
            newErrors.password = 'Password is required';
        } else if (formData.password.length < 6) {
            newErrors.password = 'Password must be at least 6 characters';
        }
        if (newErrors.email || newErrors.password) {
            setErrors(newErrors);
            return;
        }

        else {
            login(formData).then(res => {
                navigate('/properties')
                setIsLoading(false);
            })
                .catch(err => {
                    setIsLoading(false);
                    setErrorMessage(err.response.data.error);
                })

            setTimeout(() => {
                setErrorMessage("");
            }, 20000);
        }
    };

    return (
        <div className='login-page'>
            <header className="header">
                <div className="logo">
                    <img className="logo-icon" src='/assets/images/icons/coralytics.webp' />
                </div>
            </header> 
            {/* Login Form */}
            <div className="login-container">
                <div className="login-card">
                    <h2 className="login-title">MEMBER LOGIN</h2>
                    {errorMessage && <div className="alert alert-danger" role="alert">{errorMessage}</div>}
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <div className="input-group">
                                <input
                                    type="email"
                                    name="email"
                                    className="form-control"
                                    placeholder="Email address"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                />
                                <i className="fa-solid fa-envelope input-icon size-20"></i>
                            </div>
                            {errors.email && (
                                <div className={`form-error ${errors.email ? 'show' : ''}`}>
                                    {errors.email}
                                </div>
                            )}
                        </div>

                        <div className="form-group">
                            <div className="input-group">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    className="form-control"
                                    placeholder="Password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                />
                                <div
                                    className="input-icon"
                                    onClick={handleShowPassword}
                                >
                                    {showPassword ? <svg width="20" height="16" className='size-20' viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10 0C5.45455 0 1.58182 2.90909 0 7.27273C1.58182 11.6364 5.45455 14.5455 10 14.5455C14.5455 14.5455 18.4182 11.6364 20 7.27273C18.4182 2.90909 14.5455 0 10 0ZM10 12.1212C7.27273 12.1212 5.09091 9.93939 5.09091 7.27273C5.09091 4.60606 7.27273 2.42424 10 2.42424C12.7273 2.42424 14.9091 4.60606 14.9091 7.27273C14.9091 9.93939 12.7273 12.1212 10 12.1212ZM10 4.84848C8.60606 4.84848 7.57576 5.87879 7.57576 7.27273C7.57576 8.66667 8.60606 9.69697 10 9.69697C11.3939 9.69697 12.4242 8.66667 12.4242 7.27273C12.4242 5.87879 11.3939 4.84848 10 4.84848Z"
                                            fill="#a3a2a2"
                                            fillOpacity="0.8"
                                        />
                                    </svg> : <svg width="19" height="16" className='size-20' viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.0189 0.881092L16.283 0.145149C16.075 -0.0628416 15.691 -0.0308325 15.451 0.257113L12.8908 2.80108C11.7388 2.30514 10.4749 2.06514 9.14682 2.06514C5.1947 2.08107 1.77092 4.38504 0.122802 7.69725C0.0267743 7.90524 0.0267743 8.16117 0.122802 8.33716C0.890735 9.90518 2.04281 11.2012 3.48281 12.1772L1.38682 14.3051C1.14682 14.5451 1.11481 14.9291 1.27485 15.1371L2.0108 15.8731C2.21879 16.081 2.60277 16.049 2.84277 15.7611L16.8907 1.71321C17.1947 1.47334 17.2267 1.08938 17.0187 0.881366L17.0189 0.881092ZM9.99481 5.71298C9.7228 5.64896 9.43485 5.56901 9.16283 5.56901C7.80278 5.56901 6.71489 6.65703 6.71489 8.01694C6.71489 8.28895 6.77891 8.57689 6.85887 8.84892L5.78675 9.90495C5.4668 9.34499 5.29081 8.72089 5.29081 8.01697C5.29081 5.88899 7.00283 4.17697 9.13081 4.17697C9.83487 4.17697 10.4588 4.35295 11.0188 4.67291L9.99481 5.71298Z" fill="#a3a2a2" fillOpacity="0.8" />
                                        <path d="M18.1709 7.69743C17.6109 6.57738 16.8749 5.56945 15.963 4.75342L12.9869 7.69743V8.01738C12.9869 10.1454 11.2749 11.8574 9.1469 11.8574H8.82695L6.93896 13.7454C7.64302 13.8893 8.37897 13.9854 9.09897 13.9854C13.0511 13.9854 16.4749 11.6814 18.123 8.35325C18.267 8.12918 18.267 7.90527 18.1709 7.69726L18.1709 7.69743Z" fill="#a3a2a2" fillOpacity="0.8" />
                                    </svg>
                                    }
                                </div>
                            </div>
                            {errors.password && (
                                <div className={`form-error ${errors.password ? 'show' : ''}`}>
                                    {errors.password}
                                </div>
                            )}
                        </div>
                        <button
                            type="submit"
                            className="btn-login"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Signing in...' : 'Login'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login